/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DcdOwnershipServiceSummary = {
    id: number;
    name: string;
    source: DcdOwnershipServiceSummary.source;
};

export namespace DcdOwnershipServiceSummary {

    export enum source {
        RSERVER = 'rserver',
        SERVICENOW = 'servicenow',
    }


}

